import { NotifyHelper } from "../../../helpers/toast";
import { ePageBaseStatus } from "../../../models/ePageBaseStatus";
import {
	eStudentMedicalHistoryActionTypeIds,
	IStudentMedicalHistoryActionTypes
} from "../../action-types/y-te/IStudentMedicalHistoryActionTypes";
import { IStudentMedicalHistoryPageStateModel } from "../../page-state-model/y-te/IStudentMedicalHistoryPageState";

const initialState: IStudentMedicalHistoryPageStateModel = {
	status: ePageBaseStatus.is_not_initialization,
	student_medical_histories: [],
	student_medical_history_details: [],
	is_exporting: false,
	export_status: ePageBaseStatus.is_not_initialization,
	health_problems: [],
	hoc_sinh_selected: {
		ts_hocsinh_id: 0,
		ma_hs: '',
		ts_hocsinh_hoten: ''
	},
	is_show_delete_confirm: false
}

export const studentMedicalHistoryReducer = (state: IStudentMedicalHistoryPageStateModel = initialState, action: IStudentMedicalHistoryActionTypes): IStudentMedicalHistoryPageStateModel => {
	switch (action.type) {
		case eStudentMedicalHistoryActionTypeIds.LOAD_START:
			return {
				...state,
				status: ePageBaseStatus.is_loading
			}
		case eStudentMedicalHistoryActionTypeIds.LOAD_SUCCESS:
			return {
				...state,
				status: ePageBaseStatus.is_completed,
				student_medical_histories: action.payload
			}
		case eStudentMedicalHistoryActionTypeIds.LOAD_ERROR:
			NotifyHelper.Error(action.payload)
			return {
				...state,
				status: ePageBaseStatus.is_completed,
				student_medical_histories: []
			}
		case eStudentMedicalHistoryActionTypeIds.LOAD_EXPORT_START:
			return {
				...state,
				export_status: ePageBaseStatus.is_loading,
				is_exporting: false,
				student_medical_history_details: []
			}
		case eStudentMedicalHistoryActionTypeIds.LOAD_EXPORT_SUCCESS:
			return {
				...state,
				export_status: ePageBaseStatus.is_completed,
				student_medical_history_details: action.payload,
				is_exporting: true
			}
		case eStudentMedicalHistoryActionTypeIds.LOAD_EXPORT_ERROR:
			NotifyHelper.Error(action.payload)
			return {
				...state,
				export_status: ePageBaseStatus.is_completed,
				student_medical_history_details: [],
				is_exporting: false
			}
		case eStudentMedicalHistoryActionTypeIds.EXPORT_COMPLETED:
			return {
				...state,
				student_medical_history_details: [],
				is_exporting: false
			}
		case eStudentMedicalHistoryActionTypeIds.LOAD_HOC_SINH_START:
			return {
				...state
			}
		case eStudentMedicalHistoryActionTypeIds.LOAD_HOC_SINH_SUCCESS:
			return {
				...state,
				hoc_sinh_selected: action.payload
			}
		case eStudentMedicalHistoryActionTypeIds.LOAD_HOC_SINH_ERROR:
			NotifyHelper.Error(action.payload)
			return {
				...state
			}
		case eStudentMedicalHistoryActionTypeIds.CHANGE_HOC_SINH_SELECTED:
			return {
				...state,
				hoc_sinh_selected: action.payload
			}
		case eStudentMedicalHistoryActionTypeIds.LOAD_BY_HOC_SINH_START:
			return {
				...state,
				status: ePageBaseStatus.is_loading
			}
		case eStudentMedicalHistoryActionTypeIds.LOAD_BY_HOC_SINH_SUCCESS:
			return {
				...state,
				status: ePageBaseStatus.is_completed,
				health_problems: action.payload
			}
		case eStudentMedicalHistoryActionTypeIds.LOAD_BY_HOC_SINH_ERROR:
			NotifyHelper.Error(action.payload)
			return {
				...state,
				status: ePageBaseStatus.is_completed,
				health_problems: []
			}
		case eStudentMedicalHistoryActionTypeIds.CHANGE_HEALTH_PROBLEMS:
			return {
				...state,
				health_problems: action.payload
			}
		case eStudentMedicalHistoryActionTypeIds.SAVE_START:
			return {
				...state,
				status: ePageBaseStatus.is_saving
			}
		case eStudentMedicalHistoryActionTypeIds.SAVE_SUCCESS:
			NotifyHelper.Success("Cập nhật thành công")
			return {
				...state,
				status: ePageBaseStatus.is_need_reload
			}
		case eStudentMedicalHistoryActionTypeIds.SAVE_ERROR:
			NotifyHelper.Error(action.payload)
			return {
				...state,
				status: ePageBaseStatus.is_completed
			}
		case eStudentMedicalHistoryActionTypeIds.SHOW_CONFIRM:
			return {
				...state,
				is_show_delete_confirm: true
			}
		case eStudentMedicalHistoryActionTypeIds.CLOSE_CONFIRM:
			return {
				...state,
				is_show_delete_confirm: false
			}
		case eStudentMedicalHistoryActionTypeIds.DELETE_START:
			return {
				...state,
				status: ePageBaseStatus.is_deleting
			}
		case eStudentMedicalHistoryActionTypeIds.DELETE_SUCCESS:
			NotifyHelper.Success("Xoá dữ liệu thành công.")
			return {
				...state,
				status: ePageBaseStatus.is_need_reload,
				is_show_delete_confirm: false
			}
		case eStudentMedicalHistoryActionTypeIds.DELETE_ERROR:
			NotifyHelper.Error(action.payload)
			return {
				...state,
				status: ePageBaseStatus.is_completed,
				is_show_delete_confirm: false
			}
		default:
			return state;
	}
}
